/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IExamplesParent } from '../../core/models/common/IExamplesParent';
import { Oas30Example } from '../../openapi/v3/models/Oas30Example';
import { Oas30Header } from '../../openapi/v3/models/Oas30Header';
import { Oas30MediaType } from '../../openapi/v3/models/Oas30MediaType';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';
import { IExample } from '../../core/models/common/IExample';

/**
 * A command used to add an Example for a 3.0 MediaType.  If an example with the same name
 * already exists, this command does nothing.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class AddExampleCommand_30 extends AbstractCommand {
    public _parentPath : NodePath;

    public _newExampleValue : any;

    public _newExampleName : string;

    public _newExampleSummary : string;

    public _newExampleDescription : string;

    public _exampleAdded : boolean;

    public constructor(parent? : any, example? : any, exampleName? : any, exampleSummary? : any, exampleDescription? : any) {
        if(((parent != null && parent instanceof <any>Oas30MediaType) || parent === null) && ((example != null) || example === null) && ((typeof exampleName === 'string') || exampleName === null) && ((typeof exampleSummary === 'string') || exampleSummary === null) && ((typeof exampleDescription === 'string') || exampleDescription === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            (() => {
                this._parentPath = Library.createNodePath(parent);
                this._newExampleValue = example;
                this._newExampleName = exampleName;
                this._newExampleSummary = exampleSummary;
                this._newExampleDescription = exampleDescription;
            })();
        } else if(((parent != null && parent instanceof <any>Oas30Header) || parent === null) && ((example != null) || example === null) && ((typeof exampleName === 'string') || exampleName === null) && ((typeof exampleSummary === 'string') || exampleSummary === null) && ((typeof exampleDescription === 'string') || exampleDescription === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            (() => {
                this._parentPath = Library.createNodePath(parent);
                this._newExampleValue = example;
                this._newExampleName = exampleName;
                this._newExampleSummary = exampleSummary;
                this._newExampleDescription = exampleDescription;
            })();
        } else if(((parent != null && parent instanceof <any>Oas30MediaType) || parent === null) && ((example != null) || example === null) && ((typeof exampleName === 'string') || exampleName === null) && exampleSummary === undefined && exampleDescription === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            (() => {
                this._parentPath = Library.createNodePath(parent);
                this._newExampleValue = example;
                this._newExampleName = exampleName;
            })();
        } else if(((parent != null && parent instanceof <any>Oas30Header) || parent === null) && ((example != null) || example === null) && ((typeof exampleName === 'string') || exampleName === null) && exampleSummary === undefined && exampleDescription === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            (() => {
                this._parentPath = Library.createNodePath(parent);
                this._newExampleValue = example;
                this._newExampleName = exampleName;
            })();
        } else if(parent === undefined && example === undefined && exampleName === undefined && exampleSummary === undefined && exampleDescription === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._newExampleSummary===undefined) this._newExampleSummary = null;
            if(this._newExampleDescription===undefined) this._newExampleDescription = null;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddExampleCommand_30] Executing.");
        this._exampleAdded = false;
        let examplesParent : IExamplesParent = <IExamplesParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(examplesParent)) {
            return;
        }
        if(!this.isNullOrUndefined(examplesParent.getExample(this._newExampleName))) {
            return;
        }
        let example : Oas30Example = <Oas30Example><any>examplesParent.createExample(this._newExampleName);
        example.summary = this._newExampleSummary;
        example.description = this._newExampleDescription;
        example.value = this._newExampleValue;
        examplesParent.addExample(example);
        this._exampleAdded = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddExampleCommand_30] Reverting.");
        if(!this._exampleAdded) {
            return;
        }
        let mediaType : Oas30MediaType = <Oas30MediaType>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(mediaType) || this.isNullOrUndefined(mediaType.examples)) {
            return;
        }
        mediaType.removeExample(this._newExampleName);
    }
}
AddExampleCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.AddExampleCommand_30";
AddExampleCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




